import type { Selector } from 'core/core.selectors';
import type { AuthState } from 'core/services/auth/auth.models';

export const getUserData: Selector<AuthState> = state => state.uiState.auth;

export const getUserId: Selector<string | undefined> = state => state.uiState.auth.user?.id;
